import { IdToken } from "@/core/models/id-token.model";
import { TokenRepository } from "./token.repository";

export abstract class IdTokenRepository extends TokenRepository<string, IdToken>{
    public abstract save(idToken: IdToken) : void;
}